import script from "./Connections.vue?vue&type=script&setup=true&lang=ts"
export * from "./Connections.vue?vue&type=script&setup=true&lang=ts"

import "./Connections.vue?vue&type=style&index=0&id=68eb2878&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68eb2878"]])

export default __exports__